// ═══════════════════════════════════════════════════════════════
//  0x72「16×16 Dungeon Tileset II」瓦片帧索引
//  tileset 为 160×160 的 spritesheet（10×10 网格，每帧 16×16）
//
//  通过分析确定：
//   - 第 0–3 行为「平整」瓦片（顶/底亮度一致）→ 地板
//   - 第 4–5 行的瓦片带「顶部高光面」（上亮下暗）→ 墙体
// ═══════════════════════════════════════════════════════════════

/** 地板：平整的紫色石砖（10×10 网格第 0 行第 6 列） */
export const FLOOR_FRAME = 6;

/** 墙体：带顶部高光面的石墙（第 4 行第 1 列） */
export const WALL_FRAME = 41;

/** 門（上）：石框木門（第 6 行第 6 列） */
export const DOOR_FRAME_UP = 66;

/** 門（下）：石框木門variant（第 6 行第 7 列） */
export const DOOR_FRAME_DOWN = 67;
